import { CustomerCoupon } from '../models/customer-coupon.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../core/services/api.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { ReferralDetails } from '../models/referral-details.model';
import { AppConfig } from '../../core/services/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class PromotionCouponsService {
  public details$: Observable<ReferralDetails>;
  public statusMessage$: Observable<string>;

  private refresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private api: ApiService, private auth: AuthStoreService, private appConfig: AppConfig) {
    this.details$ = this.refresh.pipe(switchMap(() => this.getReferralDetails()));
    this.statusMessage$ = this.details$.pipe(
      map((state) => PromotionCouponsService.buildMessage(state, appConfig.config?.visaContest?.enabled)),
    );
  }

  private static buildMessage(referral?: ReferralDetails, visaContestEnabled?: boolean): string {
    if (visaContestEnabled) {
      return 'Wygraj 10 000 zł';
    }

    if (!referral || (referral.activeAmount === 0 && referral.amountEarned >= referral.amountLimit)) {
      return 'Poleć znajomym';
    }
    if (referral.activeAmount > 0) {
      return `Masz ${referral.activeAmount} zł na opłaty`;
    }
    if (referral.inactiveCampaignCouponSum > 0) {
      return `Odblokuj ${referral.inactiveCampaignCouponSum} zł na opłaty`;
    }
    return `Zdobądź do ${referral.amountLimit} zł na opłaty`;
  }

  public getReferralDetails(): Observable<ReferralDetails> {
    return this.api.get<ReferralDetails>(
      `/customer/${this.auth.userInfo.customer_id}/referralDetails`,
      null,
      true,
      'customer/referralDetails',
      ([data, socketFrame]) => (socketFrame ? socketFrame : data),
    );
  }

  public getAvailableCouponsForCustomer(): Observable<CustomerCoupon[]> {
    return this.api.get<CustomerCoupon[]>(`/customer-coupons/available`);
  }

  public getReferralDetailsForCustomer(customerId: string): Observable<ReferralDetails> {
    return this.api.get<ReferralDetails>(`/customer/${customerId}/referralDetails`, null, false);
  }

  public addPromotionCode(customerId: string, couponCode: string): Observable<void> {
    return this.api.post(`/customers/${customerId}/coupon-codes`, { couponCode });
  }

  public addPromotionCodeToPayment(customerId: string, couponCode: string, paymentId: string): Observable<string> {
    return this.api.post(`/customers/${customerId}/coupon-codes/use-with-payment`, { couponCode, paymentId });
  }

  public inviteByEmails(customerId: string, emails: string[]): Observable<any> {
    return this.api.post(`/customers/${customerId}/invite`, { emails });
  }

  public refreshCoupons() {
    this.refresh.next(true);
  }
}
